import { styled as muiStyled, css as muiCss } from '@mui/material/styles';

// @ts-ignore
const styled = (...rest) => muiStyled(...rest);
export const css = (...args) => muiCss(...args);

export default styled;
